module.exports = __webpack_public_path__ + "img/tenant_console_logo_name@3x.323e7870.png";